import { Address, Classification, DocumentStatus, FunctionalAsset } from '@synergy/models';
import { fields } from '@synergy/utils';

import { Account } from '../../../../common/models/account';
import { Contact } from '../../../../common/models/contact';
import { PaymentTerm } from '../../../../common/models/payment-term';
import { PoolBankInfo } from '../../../../common/models/pool-bank-info';
import { Supplier } from '../../../../common/models/supplier';

export interface OverviewFormValues {
    id?: number;
    status: DocumentStatus;
    isCredit: boolean;
    currency?: string;
    poolBankInfo?: PoolBankInfo | null;
    poolBankInfoId?: number;
    responsibleContact: Contact | null;
    invoiceDate: Date;
    paymentTerm: PaymentTerm | null;
    shouldSendEmail: boolean;

    costCentre: string;
    orderReference: string;
    orderDate?: Date;
    functionalAsset?: FunctionalAsset | null;
    functionalAssetId?: number;

    supplierAccount: Supplier | null;
    supplierContact: Contact | null;
    deliveryNumber: string;
    deliveryDate?: Date;
    incomingInvoiceNumber?: string;

    recipientAccount: Account | null;
    recipientContact: Contact | null;
    invoiceAddress?: Address | null;
    recipientOrderContact?: Contact | null;

    noteToRecipient: string;
    internalNote: string;

    number?: string;
    classifications?: Classification[];
}

export const overviewFieldNames = fields<OverviewFormValues>();
